
(function () {
  const STORAGE_KEY = 'dfl_buyer_request_v1';

  function readItems() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateCounts(items);
  }

  function updateCounts(items) {
    const count = items.reduce((total, item) => total + Number(item.quantity || 0), 0);
    document.querySelectorAll('[data-buyer-request-count]').forEach((node) => {
      node.textContent = String(count);
    });
  }

  function setNotice(card, message) {
    const notice = card.querySelector('[data-buyer-notice]');
    if (!notice) return;
    notice.textContent = message;
    window.setTimeout(() => {
      if (notice.textContent === message) notice.textContent = '';
    }, 2600);
  }

  function addFromCard(button) {
    const card = button.closest('[data-buyer-product-card]');
    if (!card) return;

    const variantSelect = card.querySelector('[data-buyer-variant]');
    const quantityInput = card.querySelector('[data-buyer-quantity]');
    const selectedOption = variantSelect && variantSelect.options[variantSelect.selectedIndex];
    const quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
    const variantId = selectedOption ? selectedOption.value : card.dataset.variantId;

    if (!variantId) {
      setNotice(card, 'Please select a product option.');
      return;
    }

    const nextItem = {
      variantId: variantId,
      productId: card.dataset.productId || '',
      productTitle: card.dataset.productTitle || '',
      variantTitle: selectedOption ? selectedOption.dataset.title || selectedOption.textContent.trim() : '',
      sku: selectedOption ? selectedOption.dataset.sku || '' : card.dataset.sku || '',
      image: card.dataset.image || '',
      url: card.dataset.url || '',
      rrp: card.dataset.rrp || '',
      currency: card.dataset.currency || 'EUR',
      quantity: quantity
    };

    const items = readItems();
    const existing = items.find((item) => item.variantId === nextItem.variantId);
    if (existing) {
      existing.quantity = Number(existing.quantity || 0) + quantity;
    } else {
      items.push(nextItem);
    }

    writeItems(items);
    setNotice(card, 'Added to request.');
  }

  function syncSku(select) {
    const card = select.closest('[data-buyer-product-card]');
    const output = card && card.querySelector('[data-buyer-sku]');
    const selectedOption = select.options[select.selectedIndex];
    if (output) output.textContent = selectedOption && selectedOption.dataset.sku ? selectedOption.dataset.sku : '—';
  }

  function buildItemRow(item, index, container) {
    const row = document.createElement('div');
    row.className = 'buyer-request-item';
    row.dataset.requestIndex = String(index);

    if (item.image) {
      const image = document.createElement('img');
      image.className = 'buyer-request-item__image';
      image.src = item.image;
      image.alt = '';
      image.loading = 'lazy';
      row.appendChild(image);
    } else {
      const placeholder = document.createElement('div');
      placeholder.className = 'buyer-request-item__image';
      row.appendChild(placeholder);
    }

    const details = document.createElement('div');
    const title = document.createElement('p');
    title.className = 'buyer-request-item__title';
    title.textContent = item.productTitle || 'Product';
    details.appendChild(title);

    if (item.variantTitle && item.variantTitle !== 'Default Title') {
      const variant = document.createElement('p');
      variant.className = 'buyer-request-item__meta';
      variant.textContent = 'Option: ' + item.variantTitle;
      details.appendChild(variant);
    }

    const sku = document.createElement('p');
    sku.className = 'buyer-request-item__meta';
    sku.textContent = 'SKU: ' + (item.sku || '—');
    details.appendChild(sku);

    if (item.rrp) {
      const rrp = document.createElement('p');
      rrp.className = 'buyer-request-item__meta';
      rrp.textContent = 'EU RRP: ' + item.currency + ' ' + item.rrp + ' (reference only)';
      details.appendChild(rrp);
    }
    row.appendChild(details);

    const quantity = document.createElement('input');
    quantity.className = 'field__input buyer-request-item__quantity';
    quantity.type = 'number';
    quantity.min = '1';
    quantity.step = '1';
    quantity.value = String(item.quantity || 1);
    quantity.setAttribute('aria-label', 'Quantity for ' + (item.productTitle || 'product'));
    quantity.addEventListener('change', function () {
      const items = readItems();
      if (!items[index]) return;
      items[index].quantity = Math.max(1, parseInt(quantity.value, 10) || 1);
      quantity.value = String(items[index].quantity);
      writeItems(items);
      updateRequestPayload(items);
    });
    row.appendChild(quantity);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'buyer-request-item__remove';
    remove.textContent = 'Remove';
    remove.addEventListener('click', function () {
      const items = readItems();
      items.splice(index, 1);
      writeItems(items);
      renderRequestList();
    });
    row.appendChild(remove);

    container.appendChild(row);
  }

  function formatPayload(items) {
    return items.map((item, index) => {
      const option = item.variantTitle && item.variantTitle !== 'Default Title' ? ' | Option: ' + item.variantTitle : '';
      const rrp = item.rrp ? ' | EU RRP: ' + item.currency + ' ' + item.rrp + ' (reference only)' : '';
      return (index + 1) + '. ' + item.productTitle + option + ' | SKU: ' + (item.sku || '—') + ' | Qty: ' + item.quantity + rrp;
    }).join('\n');
  }

  function updateRequestPayload(items) {
    const payload = document.querySelector('[data-buyer-request-payload]');
    if (payload) payload.value = formatPayload(items);
  }

  function renderRequestList() {
    const container = document.querySelector('[data-buyer-request-list]');
    if (!container) return;

    const items = readItems();
    container.textContent = '';
    items.forEach((item, index) => buildItemRow(item, index, container));

    const empty = document.querySelector('[data-buyer-request-empty]');
    const form = document.querySelector('[data-buyer-request-form]');
    const submitted = Boolean(document.querySelector('[data-buyer-request-success]'));
    if (empty) empty.hidden = items.length > 0 || submitted;
    if (form) form.hidden = items.length === 0 && !submitted;
    updateRequestPayload(items);
    updateCounts(items);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-add-to-buyer-request]');
    if (button) addFromCard(button);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-buyer-variant]')) syncSku(event.target);
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateCounts(readItems());
    renderRequestList();
    document.querySelectorAll('[data-buyer-variant]').forEach(syncSku);
  });
})();
